document.addEventListener('DOMContentLoaded', function () {
  setTimeout(initCustomerStories, 100);

  function initCustomerStories() {
    const storiesBlocks = document.querySelectorAll('.customer-stories');

    storiesBlocks.forEach((block, blockIndex) => {
      const slider = block.querySelector('.customer-stories__slider');
      const progressBar = block.querySelector('.customer-stories__progress-bar');
      const progressContainer = block.querySelector('.customer-stories__progress-container');

      // Variables to track drag-to-scroll on the slider itself
      let isSliderDown = false;
      let sliderStartX;
      let sliderScrollLeft;
      let didDragSlider = false;

      if (slider && progressBar && progressContainer) {
        let isDragging = false;

        // --- CUSTOM SCROLLBAR LOGIC ---
        function updateScrollbar() {
          const sliderWidth = slider.clientWidth;
          const scrollWidth = slider.scrollWidth;
          const maxScrollLeft = scrollWidth - sliderWidth;

          if (maxScrollLeft <= 0) {
            progressBar.style.width = '100%';
            progressBar.style.left = '0';
            return;
          }

          const thumbWidthPercent = (sliderWidth / scrollWidth) * 100;
          const scrollRatio = slider.scrollLeft / maxScrollLeft;
          const maxThumbTravel = 100 - thumbWidthPercent;
          const thumbLeftPercent = scrollRatio * maxThumbTravel;

          progressBar.style.width = `${thumbWidthPercent}%`;
          progressBar.style.left = `${thumbLeftPercent}%`;
        }

        function scrollToPosition(clientX) {
          const rect = progressContainer.getBoundingClientRect();
          const relativeX = clientX - rect.left;
          const sliderWidth = slider.clientWidth;
          const scrollWidth = slider.scrollWidth;
          const maxScrollLeft = scrollWidth - sliderWidth;

          if (maxScrollLeft <= 0) return;

          const thumbWidthPx = (sliderWidth / scrollWidth) * rect.width;
          let thumbLeftPx = relativeX - (thumbWidthPx / 2);
          const maxThumbLeftPx = rect.width - thumbWidthPx;
          
          let scrollRatio = thumbLeftPx / maxThumbLeftPx;
          scrollRatio = Math.max(0, Math.min(1, scrollRatio));

          slider.scrollLeft = scrollRatio * maxScrollLeft;
        }

        slider.addEventListener('scroll', updateScrollbar);
        window.addEventListener('resize', updateScrollbar);

        // Progress bar drag handlers
        progressContainer.addEventListener('mousedown', (e) => {
          isDragging = true;
          progressContainer.classList.add('is-dragging');
          scrollToPosition(e.clientX);
          e.preventDefault();
        });

        document.addEventListener('mousemove', (e) => {
          if (isDragging) {
            scrollToPosition(e.clientX);
            e.preventDefault();
          }
        });

        document.addEventListener('mouseup', () => {
          if (isDragging) {
            isDragging = false;
            progressContainer.classList.remove('is-dragging');
          }
        });

        // Touch handlers for progress bar
        let touchStarted = false;
        progressContainer.addEventListener('touchstart', (e) => {
          touchStarted = true;
          isDragging = true;
          progressContainer.classList.add('is-dragging');
          if (e.touches.length > 0) {
            scrollToPosition(e.touches[0].clientX);
          }
          e.preventDefault();
        }, { passive: false });

        document.addEventListener('touchmove', (e) => {
          if (isDragging && touchStarted && e.touches.length > 0) {
            scrollToPosition(e.touches[0].clientX);
            e.preventDefault();
          }
        }, { passive: false });

        document.addEventListener('touchend', () => {
          if (touchStarted) {
            isDragging = false;
            touchStarted = false;
            progressContainer.classList.remove('is-dragging');
          }
        });

        // --- NEW: DIRECT DRAG TO SCROLL ON THE SLIDER ---
        slider.addEventListener('mousedown', (e) => {
          isSliderDown = true;
          didDragSlider = false; // Reset drag tracker
          
          // Note: Removed slider.classList.add('is-grabbing') from here
          // so that it doesn't instantly block clicks.
          
          sliderStartX = e.pageX - slider.offsetLeft;
          sliderScrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseleave', () => {
          isSliderDown = false;
          slider.classList.remove('is-grabbing');
        });

        slider.addEventListener('mouseup', () => {
          isSliderDown = false;
          slider.classList.remove('is-grabbing');
        });

        slider.addEventListener('mousemove', (e) => {
          if (!isSliderDown) return;
          e.preventDefault(); // Prevents text/image selection
          
          const x = e.pageX - slider.offsetLeft;
          const walk = (x - sliderStartX) * 1.5; // Scroll speed multiplier
          
          // If moved more than 5px, consider it a drag, not a click
          if (Math.abs(walk) > 5) {
            didDragSlider = true;
            slider.classList.add('is-grabbing'); // Only add pointer-events block if actually dragging
          }
          
          slider.scrollLeft = sliderScrollLeft - walk;
        });

        // Initial updates
        setTimeout(updateScrollbar, 100);
        setTimeout(updateScrollbar, 300);
        setTimeout(updateScrollbar, 500);
        setTimeout(updateScrollbar, 1000);
      }

      // --- VIDEO PLAY/PAUSE LOGIC ---
      const cards = block.querySelectorAll('.customer-story__card');
      cards.forEach(card => {
        card.addEventListener('click', function (e) {
          // If the user was just dragging the slider, do not play/pause
          if (didDragSlider) {
            e.preventDefault();
            return;
          }

          const video = this.querySelector('video');
          const icon = this.querySelector('.customer-story__play-icon');

          if (video) {
            if (video.paused) {
              // Pause all other videos
              block.querySelectorAll('video').forEach(v => {
                if (v !== video && !v.paused) {
                  v.pause();
                  const otherIcon = v.closest('.customer-story__card')?.querySelector('.customer-story__play-icon');
                  if (otherIcon) otherIcon.style.opacity = '1';
                }
              });

              video.play();
              if (icon) icon.style.opacity = '0';
            } else {
              video.pause();
              if (icon) icon.style.opacity = '1';
            }
          }
        });
      });
    });
  }
});